import { colors } from "@resurs/midas"

export default {
  noMargin: {
    margin: 0,
  },
  resurs: {
    background: colors.primaryMain,
  },
}
